var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stats__transactions__item w-full sm:w-1/3 md:w-1/5 xl:flex-grow min-w-32 py-2"},[_c('div',{staticClass:"stats__transactions__value font-bold"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('div',{staticClass:"stats__transactions__title uppercase text-grey-500"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }